import useStore, { updateScreenWidth } from '../Store/Store';

import { Box, Button, IconButton, InputAdornment, Link, TextField, Typography } from '@mui/material';
import React from 'react';
import Logo from '../images/logo.png';
import SideImage from '../images/loginImage.svg';
import { resetPassword } from '../utils/api';
import { useMutation } from 'react-query';
import { useNavigate, useLocation } from 'react-router-dom';
import { isEmpty } from 'lodash';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import queryString from 'query-string';
import DoneIcon from '@mui/icons-material/Done';

const ResetPassword = () => {
  const location = useLocation();
  const urlParams = queryString.parse(location.search);
  const accessToken = urlParams.access_token;
  const history = useNavigate();
  const user = useStore((state) => state.user);
  const width = useStore((state) => state.screenWidth);
  const [state, setState] = React.useState({
    password: '',
    errorMessage: '',
    showPassword: false,
  });
  const [passwordChecker, setPasswordChecker] = React.useState({
    length: false,
    number: false,
    special: false,
  });

  const updateDimensions = () => {
    updateScreenWidth(window.innerWidth);
  };
  React.useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  const resetPasswordHandler = useMutation(resetPassword, {
    onSuccess: async ({ data }) => {
      history('/main');
    },
    onError: (error) => {
      console.log('error =====> ', error);
      setState({ errorMessage: error?.response?.data?.message || 'Something went wrong!' });
    },
  });

  const handleReset = async () => {
    if (!state.password) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'Password is required fields' };
      });
    }

    const { length, number, special } = passwordChecker;
    if (!length || !number || !special) {
      return setState((prev) => {
        return { ...prev, errorMessage: 'Password not matched with policy!' };
      });
    }

    setState((prev) => {
      return { ...prev, errorMessage: '' };
    });

    resetPasswordHandler.mutate({ password: state.password, accessToken });
  };

  React.useEffect(() => {
    if (!isEmpty(user)) {
      history('/main');
    }
  }, [user]);

  const handleSetPassword = (event) => {
    const { value } = event.target;

    if (value.length > 8) {
      setPasswordChecker((prev) => {
        return { ...prev, length: true };
      });
    } else {
      setPasswordChecker((prev) => {
        return { ...prev, length: false };
      });
    }
    if (/[0-9]/.test(value)) {
      setPasswordChecker((prev) => {
        return { ...prev, number: true };
      });
    } else {
      setPasswordChecker((prev) => {
        return { ...prev, number: false };
      });
    }
    if (/[^a-zA-Z0-9]/.test(value)) {
      setPasswordChecker((prev) => {
        return { ...prev, special: true };
      });
    } else {
      setPasswordChecker((prev) => {
        return { ...prev, special: false };
      });
    }

    setState((prev) => {
      return { ...prev, password: event.target.value };
    });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100vw',
        height: '100vh',
        backgroundColor: 'white',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: width > 1050 ? '50%' : '100%',
          padding: '1rem',
        }}
      >
        <Box
          component="img"
          sx={{ width: '55px', height: '37.56px', marginBottom: '2rem' }}
          alt="Mask group"
          src={Logo}
        />
        <div style={{ paddingInline: '4rem', paddingBlock: '12rem' }}>
          <Typography variant="h4" gutterBottom mb={6}>
            Reset your password
          </Typography>

          <TextField
            label="Password"
            variant="outlined"
            fullWidth
            type={state.showPassword ? 'text' : 'password'}
            sx={{ marginBottom: '1rem', borderRadius: '50px' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    onClick={() =>
                      setState((prev) => {
                        return { ...prev, showPassword: !state.showPassword };
                      })
                    }
                  >
                    {!state.showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                  </IconButton>
                </InputAdornment>
              ),
              style: { borderRadius: '50px' },
            }}
            onChange={handleSetPassword}
          />

          <div style={{ display: 'flex', fontSize: '13px', marginBottom: '20px' }}>
            <div style={{ display: 'flex', color: passwordChecker.length ? '#01796b' : 'grey' }}>
              <DoneIcon style={{ fontSize: '17px', marginRight: '5px' }} /> Min 8 characters
            </div>
            <div style={{ display: 'flex', marginInline: '20px', color: passwordChecker.number ? '#01796b' : 'grey' }}>
              <DoneIcon style={{ fontSize: '17px', marginRight: '5px' }} /> 1 number
            </div>
            <div style={{ display: 'flex', color: passwordChecker.special ? '#01796b' : 'grey' }}>
              <DoneIcon style={{ fontSize: '17px', marginRight: '5px' }} /> 1 special character
            </div>
          </div>

          <Button
            variant="contained"
            fullWidth
            sx={{
              borderRadius: '50px',
              marginBottom: '1rem',
              background: '#01796b',
            }}
            onClick={handleReset}
            disabled={resetPasswordHandler.isLoading}
          >
            {resetPasswordHandler.isLoading ? 'loading...' : 'Reset Password'}
          </Button>

          <Typography component="h1" variant="subtitle1" style={{ color: 'red' }} textAlign="center" my={1}>
            {state.errorMessage}
          </Typography>

          <Typography variant="body2">
            Back to
            <Link
              variant="body2"
              style={{
                color: '#01796b',
                textDecoration: 'none',
                cursor: 'pointer',
                fontWeight: 'bold',
                marginInline: '4px',
              }}
              href="/#/login"
            >
              Login
            </Link>
            or
            <Link
              variant="body2"
              style={{
                color: '#01796b',
                textDecoration: 'none',
                cursor: 'pointer',
                fontWeight: 'bold',
                marginInline: '4px',
              }}
              href="/#/sign-up"
            >
              Sign Up
            </Link>
          </Typography>
        </div>
      </Box>
      {width > 1050 && (
        <Box
          component="img"
          sx={{
            width: '50%',
            height: '97%',
            objectFit: 'cover',
            padding: '1rem',
            borderRadius: '30px',
          }}
          alt="Rectangle"
          src={SideImage}
        />
      )}
    </Box>
  );
};

export default ResetPassword;
